*:focus {
	outline: var(--oebb-outline, 2px dotted var(--oebb-accent-color, #e2002a));
	outline-offset: var(--oebb-outline-offset, 2px);
}

*:focus:not(:focus-visible) {
	outline: none;
}

*:focus-visible {
	outline: var(--oebb-outline, 2px dotted var(--oebb-accent-color, #e2002a));
	outline-offset: var(--oebb-outline-offset, 2px);
}

.hidden {
	display: none;
}

.invisible {
	visibility: hidden;
}

.offscreen {
	position: absolute;
	left: -1000em;
}

.screen-reader-text {
	position: absolute;

	width: 1px;
	height: 1px;
	margin: -1px;
	padding: 0;
	overflow: hidden;

	border: 0;
	clip-path: inset(50%);

	white-space: nowrap;
}

.screen-reader-text--focusable:active,
.screen-reader-text--focusable:focus {
	position: relative;

	width: auto;
	height: auto;
	margin: 0;
	overflow: visible;

	clip-path: none;

	white-space: inherit;
}

/** @deprecated */
/** ".is-tabbing" should be added via JavaScript and shows the outline. Used with class to not show outline on clicking elements. */
.is-tabbing button::-moz-focus-inner,
:host(.is-tabbing) button::-moz-focus-inner {
	border: 0;
}

.is-tabbing--focus,
.is-tabbing a:focus,
.is-tabbing button:focus,
.is-tabbing div:focus,
.is-tabbing input:focus,
.is-tabbing input:focus ~ span[role="presentation"],
:host(.is-tabbing) a:focus,
:host(.is-tabbing) button:focus,
:host(.is-tabbing) div:focus,
:host(.is-tabbing) input:focus,
:host(.is-tabbing) input:focus ~ span[role="presentation"] {
	outline: 2px dotted #e2002a;
	outline-offset: 2px;
	z-index: 10;
}


:host {
	position: relative;
	z-index: 10;

	display: inline-block;
	min-width: 295px;
	padding: 0;
	box-sizing: border-box;

	background: transparent;
	white-space: nowrap;
	font-size: 0;
}

.date-field {
	position: relative;
	width: calc(100% - 35px);
	box-sizing: border-box;
	top: 0;
	left:0;
	border: 1px solid #ccc;
	font-size:0;
}

.date-field.focus {
	border: 1px solid #ccc;
	box-shadow: 0 1px 10px 0 rgba(50, 50, 50, 0.75);
}

input[type=text]{
	display: inline-block;
	box-sizing: border-box;
	font-size: 16px;
	height: 32px;
	line-height: 32px;
	border: none;
	padding:0 36px 0 86px;
	text-align: left;
	width: 100%;
	min-width: 222px;
}

input:focus {
	outline: 0;
	font-size: 16px;
}

input:active,
input:hover {
	outline: 0;
}

input[type=text].label-outside {
	padding: 0;
	text-align: center;
}

button {
	display: inline-block;
	position:absolute;
	top:0;
	box-sizing: border-box;
	border: none;
	background: #efefef;
	width:32px;
	height:32px;
	fill: #6a6a6a;
	cursor: pointer;
}

button:first-child{
	left: 0;
}

button:last-child{
	right :0;
}

button:hover,
button:focus {
	background: #f5f5f5;
	fill: #000;
}

button:focus {
	outline: var(--oebb-outline);
	outline-offset: var(--oebb-outline-offset);
}

button:focus:not(:focus-visible) {
	outline: none;
}

button:focus-visible {
	outline: var(--oebb-outline);
	outline-offset: var(--oebb-outline-offset);
}

button[disabled],
button[disabled]:focus,
button[disabled]:hover {
	background: #efefef;
	cursor: not-allowed;
	fill: #aaa;
}

.calendar-btn{
	position: absolute;
	top: 50%;
	right: 0;
	transform: translateY(-50%);
	display: inline-block;
	box-sizing: border-box;
	background: transparent;
	width: 35px;
	fill: #6a6a6a;
	cursor: pointer;
	border:1px solid transparent;
	padding: 0;
}

.calendar-btn:hover,
.calendar-btn:focus {
	outline: 0;
	background: transparent;
	fill: #000;
}

label {
	display: inline-block;
	position: absolute;
	box-sizing: border-box;
	height: 32px;
	line-height: 30px;
	left: 35px;
	top:0;
	font-size: 16px;
	color: #666;
	padding-top:1px;
}

button{
	font-size: 14px;
}

.error{
	font-size:16px;
}

.error,
.error * {
	color: #E2002A;
}

.error g {
	color: #ffffff;
	fill: #E2002A;
}

.error input[type=text] {
	border-color: #E2002A;
	color: #E2002A;
}

.date-validation-error{
	position: relative;
	top:-30px;
}

.fm-label-danger {
	border: 1px solid #bd352e;
	background: #f2d7d5;
	display: inline-block;
	margin-top: 6px;
	margin-right: 6px;
	padding: .3em .6em .3em .6em;
	font-size: 12px;
	font-weight: bold;
	line-height: 1;
	color: #bd352e;
	text-align: center;
	white-space: nowrap;
	vertical-align: baseline;
	border-radius: 0;
}
